import { addOnSchema } from './add-on';
import { coercedDate } from '../../../utils/coerced-date';
import { z } from 'zod/v4';

export const productAssignmentSchema = z.object({
  productId: z.number().min(1),
  productAccountId: z.number().min(1),
  productName: z.string().min(1),
  addons: z.array(addOnSchema).nullable().optional(),
  onboardEmailSent: coercedDate.nullable(),
  onboardSMSSent: coercedDate.nullable(),
  firstActivation: coercedDate.nullable(),
  lastActivity: coercedDate.nullable(),
});

export type ProductAssignment = z.infer<typeof productAssignmentSchema>;
